// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"40672c36","178":"6802067e","201":"acc0806b","301":"81bc5dd5","455":"ae46bb3c","488":"7e1d6039","590":"517cd9d1","675":"c3178b21","859":"006d20c6","864":"da3b33dc","887":"0cdc0a55"}[chunkId] + ".chunk.js";
};